var _defs, _circle, _g, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPressureBoxed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 491.62 491.62",
    fill: "currentcolor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    fill: "currentcolor"
  }, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{\n                fill:none;\n                stroke:#fff;\n                stroke-miterlimit:10;\n                stroke-width:19px;\n                }\n        "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 247.71,
    cy: 243.33,
    r: 150.61,
    fill: "currentcolor"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    d: "M431,490H60.77A58.38,58.38,0,0,1,2,431.25V61A58.37,58.37,0,0,1,60.77,2.31H431A58.37,58.37,0,0,1,489.72,61V431.25C490.46,464,463.7,490,431,490ZM60.77,24.61A36.48,36.48,0,0,0,24.35,61V431.25a36.49,36.49,0,0,0,36.42,36.43H431a36.49,36.49,0,0,0,36.43-36.43V61A36.49,36.49,0,0,0,431,24.61Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    d: "M247.71,405.93c89.66,0,162.6-72.94,162.6-162.6S337.37,80.72,247.71,80.72,85.1,153.67,85.1,243.33,158,405.93,247.71,405.93Zm0-301.21c76.42,0,138.6,62.18,138.6,138.61s-62.18,138.6-138.6,138.6S109.1,319.75,109.1,243.33,171.28,104.72,247.71,104.72Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    d: "M318.09,170.06l-72.43,43.82a32.27,32.27,0,1,0,32.46,33.83l44.34-73.29a3.18,3.18,0,0,0-4.37-4.36Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    d: "M245.89,83.54c-89.66,0-162.61,72.94-162.61,162.6s72.95,162.61,162.61,162.61S408.5,335.8,408.5,246.14,335.55,83.54,245.89,83.54Zm0,301.21c-76.43,0-138.61-62.18-138.61-138.61s62.18-138.6,138.61-138.6S384.5,169.72,384.5,246.14,322.32,384.75,245.89,384.75Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPressureBoxed);
export default __webpack_public_path__ + "static/media/pressure_boxed.5b95ad72.svg";
export { ForwardRef as ReactComponent };